export const Retrieve = {
    getPartialSessionMsg(_this, incompletedSessionNumber, SelectedSession, byDate, from, to) {
        if (byDate) {
            return _this.$t('global.partial_sessions_by_date', { x1: incompletedSessionNumber, x2: SelectedSession, from: from, to: to })
        } else {
            return _this.$t('global.partial_sessions', { x1: incompletedSessionNumber, x2: SelectedSession })
        }
    },
    getPartialSession2Msg(_this, byDate, from, to) {
        if (byDate) {
            return _this.$t('global.partial_sessions2_by_date', { from: from, to: to })
        } else {
            return _this.$t('global.partial_sessions2')
        }
    },
    getDownloadSuccessMsg(_this, byDate, from, to) {
        if (byDate) {
            return _this.$t('global.download_success_by_date', { from: from, to: to })
        } else {
            return _this.$t('global.download_success')
        }
    },
    getNoFilesToImportMsg(_this, byDate, from, to) {
        if (byDate) {
            return _this.$t('global.no_files_to_import_by_date', { from: from, to: to })
        } else {
            return _this.$t('global.no_files_to_import')
        }
    },
}
